import { CSSProperties } from 'react';
import styles from './Badge.module.css';

export type BadgeVariants =
  | 'primary'
  | 'secondary'
  | 'light'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info';

type BadgeProps = {
  variant?: BadgeVariants;
  style?: CSSProperties;
  children: React.ReactNode;
};

const Badge = ({ variant, children, style }: BadgeProps) => {
  return (
    <div
      style={style}
      className={[styles.badge, variant ? styles[variant] : null].join(' ')}
    >
      {children}
    </div>
  );
};

export default Badge;
